<template>
  <v-app>
    <v-toolbar>
      <v-spacer />
      <v-toolbar-title>アリスぶ</v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      items: [{
        icon: 'bubble_chart',
        title: 'Inspire'
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Vuetify.js'
    }
  },
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue